import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { getUnreadNotificationsCount } from 'modules/notifications/selectors/ui/unread';

import { Badge, Dropdown } from '../base';
import NotificationsDropdown from './notifications/NotificationsDropdown';
import * as stylesHeader from '../layout/header/Header.module.less';

const NotificationsButton = () => {
  const unreadCount = useSelector(getUnreadNotificationsCount);

  const popupRender = React.useCallback(
    () => (
      <div className="dropdown-content mt-2">
        <NotificationsDropdown />
      </div>
    ),
    []
  );

  return (
    <Dropdown popupRender={popupRender}>
      <a
        className={classNames(stylesHeader['header-usernav__link'], stylesHeader['header-usernav__wrapper'])}
        data-cy="notifications_Navigation_Btn"
      >
        <Badge size="small" count={unreadCount} overflowCount={9} style={{ boxShadow: 'none' }}>
          <span className={classNames(stylesHeader['header-usernav__icon'], 'mr-0 fb-icon--bell')} />
        </Badge>
      </a>
    </Dropdown>
  );
};

export default NotificationsButton;
